import React from 'react';
import 'twin.macro';
import Select from 'components/Form/Select2';
import { useTranslation } from 'react-i18next';
import { Gender } from 'types/gender';
import { ROSelect } from 'containers/Eleves/List/Table/Cells/components/ROSelect';
import { getGenderLabelKey } from 'queries/eleves/serializer';

interface Props {
  value: Gender;
  onChange: (v: Gender) => any;
  readonly?: boolean;
}

export function GenderCell(props: Props) {
  const { value, onChange, readonly } = props;
  const { t } = useTranslation(['eleve']);
  const [gender, setGender] = React.useState<Gender>(value);
  const genderLabelKey = getGenderLabelKey(gender);

  const [editing, setEditing] = React.useState<boolean>(false);
  if (readonly) {
    return <div>{genderLabelKey && t(`eleve:fields.${genderLabelKey}`)}</div>;
  }

  if (!editing) {
    return (
      <div tw="w-[5rem]">
        <ROSelect onClick={() => setEditing(true)}>
          {genderLabelKey && t(`eleve:fields.${genderLabelKey}`)}
        </ROSelect>
      </div>
    );
  }

  return (
    <div tw="w-[5rem]">
      <Select<Gender>
        tw="border-opacity-0 hover:bg-transparent hover:border-opacity-100 px-1"
        withoutCheck
        withoutChevron
        portal
        openOnMount
        value={gender}
        onClickOutside={() => setEditing(false)}
        onChange={v => {
          if (v !== gender || value) {
            setGender(v);
            onChange(v);
          }
          setEditing(false);
        }}
        options={[
          {
            label: t('eleve:fields.boy'),
            value: 'H',
          },
          {
            label: t('eleve:fields.girl'),
            value: 'F',
          },
        ]}
      />
    </div>
  );
}
